var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.4583C10.7502 14.4583 11.3583 13.8502 11.3583 13.1C11.3583 12.3498 10.7502 11.7417 10 11.7417C9.24981 11.7417 8.64166 12.3498 8.64166 13.1C8.64166 13.8502 9.24981 14.4583 10 14.4583Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2334 7.94167V6.9C15.2334 4.65 14.6917 1.66667 10 1.66667C5.30835 1.66667 4.76669 4.65 4.76669 6.9V7.94167C2.43335 8.23334 1.66669 9.41667 1.66669 12.325V13.875C1.66669 17.2917 2.70835 18.3333 6.12502 18.3333H13.875C17.2917 18.3333 18.3334 17.2917 18.3334 13.875V12.325C18.3334 9.41667 17.5667 8.23334 15.2334 7.94167ZM10 15.6167C8.60835 15.6167 7.48335 14.4833 7.48335 13.1C7.48335 11.7083 8.61669 10.5833 10 10.5833C11.3834 10.5833 12.5167 11.7167 12.5167 13.1C12.5167 14.4917 11.3917 15.6167 10 15.6167ZM6.12502 7.86667C6.05835 7.86667 6.00002 7.86667 5.93335 7.86667V6.9C5.93335 4.45834 6.62502 2.83334 10 2.83334C13.375 2.83334 14.0667 4.45834 14.0667 6.9V7.875C14 7.875 13.9417 7.875 13.875 7.875H6.12502V7.86667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6a05ff6f63a54ac0df7dd3e4c014ec19.svg";
export { ForwardRef as ReactComponent };